import mapValues from 'lodash/mapValues';
import toPairs from 'lodash/toPairs';

import { list, LIST_KEY } from '../domains/i18n/selectors';

interface CountryOption {
  key: string;
  label: string;
  value: string;
}

const countryOptionsByLanguage: Record<string, CountryOption[]> = mapValues(
  list[LIST_KEY.COUNTRY_MAP],
  (countries) =>
    toPairs(countries).map(([countryCode, text]) => ({
      key: countryCode,
      label: text,
      value: countryCode,
    })),
);

export const useGetCountriesOptions = (locale = 'en') =>
  countryOptionsByLanguage[locale];
